import { PROPERTY_DATA_IMAGE_METADATA_API } from '../constants/AppConstants';
/**
 * Service to request SLA property data
 * @param {string} completeAddress - The complete address for property data request
 * @returns {Promise} - API response promise
 */
const propertyDataImageMetadataRequestService = async ({ latitude, longitude }) => {
  const requestBody = {
    center: {
      point: {
        geojson: {
          value: `{"type":"Point","coordinates":[${longitude},${latitude}]}`,
        },
      },
      radius_in_meters: 50,
    },
    view: {
      orthos: {},
      max_images_per_view: 1,
    },
    response_props: {
      shot_time: true,
      zoom_range: true,
      image_resources: {
        tilebox: true,
      },
    },
  };

  try {
    const response = await fetch(PROPERTY_DATA_IMAGE_METADATA_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody),
    });
    const json = await response.json();
    if (response.status !== 200) return { ok: false, json, status: response.status };

    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};

export default propertyDataImageMetadataRequestService;
